import { render } from "./RecipeEdit.vue?vue&type=template&id=f2f47f7e"
import script from "./RecipeEdit.vue?vue&type=script&lang=js"
export * from "./RecipeEdit.vue?vue&type=script&lang=js"
script.render = render

export default script